/* Sepet cekmecesi bu temada bozuk. TUM cihazlarda sepeti CALISAN /cart sayfasina goturur.
   - Sepete ekleme yonlendirmesini, yaniti dogruladiktan sonra ilgili buton yonetir.
   - Sepet ikonu (/cart linki): tiklaninca dogrudan /cart'a git.
   Cekmece tamamen display:none -> sayfada yer kaplamaz, yanlis yonlendirme olmaz. */
(function () {
  if (location.pathname.indexOf('/cart') === 0) return;
  var going = false;
  try { var _al = window.alert; window.alert = function (m) { try { if (String(m).indexOf("Load failed") !== -1) return; } catch (e) {} return _al.apply(window, arguments); }; } catch (e) {}
  function toCart() { if (going) return; going = true; location.assign('/cart'); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // Sepet ikonu: cekmece acan buton (drawer trigger) veya /cart linki -> dogrudan /cart
    var trigger = t.closest('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"], cart-icon');
    var a = t.closest('a[href]');
    var h = a ? (a.getAttribute('href') || '') : '';
    var isCartLink = a && /\/cart(?:$|\?|\/)/.test(h) && h.indexOf('/cart/add') === -1;
    if (trigger || isCartLink) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      toCart();
    }
  }, true);
})();
/* Bellore sepet gorunurluk yamasi: satir icerigini (urun/gorsel/birim fiyat) her tarayicida
   zorla goster. Bazi tarayicilarda (ozellikle iOS) sepet satirlari DOM'da var ama gizli kaliyordu. */
(function () {
  try {
    var css = 'cart-items,cart-items:not(:defined),cart-drawer,cart-drawer:not(:defined),'
      + '.cart-items__wrapper,.cart-form,.cart-items,.cart-items__table,.cart-items__table-row,'
      + '.cart-items__media,.cart-items__details,.cart-items__quantity,.cart-items__price,'
      + '.cart-items__product-info,.cart-items__title-row,.cart-items__title,.cart-items__media-container,'
      + '.cart-items__media-image,.cart-items__variants-wrapper,.cart-items__unit-price-wrapper,'
      + 'text-component,text-component:not(:defined)'
      + '{visibility:visible!important;opacity:1!important;}'
      + 'cart-items,cart-items:not(:defined){display:block!important;}'
      + '.cart-items__wrapper{display:flex!important;}'
      + '.cart-form{display:block!important;}'
      + '.cart-items__table{display:table!important;}'
      + '.cart-items__table-row{display:grid!important;}'
      + 'dialog.theme-drawer__dialog:has(.cart-items__wrapper),dialog.theme-drawer__dialog:has(.cart-form){display:none!important;}';
    var st = document.createElement('style');
    st.setAttribute('data-bp-cart-fix', '1');
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
})();
/* Declarative Shadow DOM polyfill (Bellore): Horizon sepet cekmecesi eklemeden sonra
   innerHTML ile yeniden basiliyor; guncel Chrome <template shadowrootmode>'u parse
   etmiyor -> urun satirlari gizli kaliyor. Kalan template'leri elle shadow root'a cevirir. */
(function () {
  function hydrate(root) {
    var tpls = (root || document).querySelectorAll("template[shadowrootmode]");
    for (var i = 0; i < tpls.length; i++) {
      var tpl = tpls[i], host = tpl.parentNode;
      if (!host) { continue; }
      if (!host.shadowRoot) {
        try {
          var sr = host.attachShadow({ mode: tpl.getAttribute("shadowrootmode") || "open" });
          sr.appendChild(tpl.content);
        } catch (e) {}
      }
      try { tpl.remove(); } catch (e) {}
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { hydrate(); });
  else hydrate();
  if (window.MutationObserver) {
    var _sched = false;
    new MutationObserver(function () {
      if (_sched) return;
      _sched = true;
      (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () { _sched = false; hydrate(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  // Fallback: Sepete Ekle vb. tiklamalardan sonra sepet cekmecesi yeniden basilir;
  // olasi stray <template shadowrootmode> icin kisa gecikmeyle hydrate et (tiklama seyrek, ucuz).
  document.addEventListener('click', function () { setTimeout(hydrate, 350); setTimeout(hydrate, 900); setTimeout(hydrate, 1600); }, true);
})();
/* Bellore kampanya JS: urun detay butonundaki toplam + miktar yani rozeti. */
(function () {
  var TAG_3AL2 = 'kampanya-3al2ode';
  var TAG_2A15 = 'kampanya-2adet15';
  var BUY_N = 3, PAY_N = 2, MIN15 = 2, PCT15 = 0.15;
  var priceById = {}, compareById = {}, tags = [], mode = null, writing = false, ready = false, rcCount = 0, rcTime = 0;

  function money(c) {
    try { return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(c / 100) + ' TL'; }
    catch (e) { return (c / 100).toFixed(2) + ' TL'; }
  }
  function metaPromo() { try { var v = window.__bpQtyPromo; return (v == null) ? '' : String(v).trim(); } catch (e) { return ''; } }
  function getHandle() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : null; }
  function atcBtn() { return document.querySelector('[id^="bpdp-atc-"]'); }
  function getQty() { var q = document.querySelector('[id^="bpdp-qty-"]'); return Math.max(1, parseInt((q && q.value) || '1', 10) || 1); }
  function selVid() { var v = document.querySelector('[id^="bpdp-vid-"]'); return v && v.value ? String(v.value) : null; }
  function unitPrice() { var id = selVid(); if (id && priceById[id] != null) return priceById[id]; var k = Object.keys(priceById); return k.length ? priceById[k[0]] : null; }
  function onSale() {
    var id = selVid();
    if (id && compareById[id] != null && priceById[id] != null) return compareById[id] > priceById[id];
    return Object.keys(priceById).some(function (k) { return compareById[k] != null && compareById[k] > priceById[k]; });
  }
  function persFee() {
    var w = document.querySelector('[data-personalization]'); if (!w) return 0;
    var t = w.querySelector('[data-personalization-toggle]'); if (!t || !t.checked) return 0;
    return parseInt(w.getAttribute('data-service-price-cents') || '0', 10) || 0;
  }
  function crossTotal() {
    var s = 0; document.querySelectorAll('.bp-cross-sell__check').forEach(function (c) { if (c.checked) s += parseInt(c.getAttribute('data-price-cents') || '0', 10) || 0; }); return s;
  }
  function productLine(unit, qty) {
    if (mode === '3al2') { var free = Math.floor(qty / BUY_N) * (BUY_N - PAY_N); return unit * (qty - free); }
    if (mode === '2a15') { return unit * qty - Math.floor(unit * Math.round(PCT15 * 100) / 100) * (function (q) { var u = 0; for (var g = 1; g < 20; g++) { u = Math.max(u, Math.floor(q / (g + 1)) * g); } return u; })(qty); }
    return unit * qty;
  }
  function recompute() {
    var btn = atcBtn(); if (!btn || !mode || btn.disabled) return;
    var txt = btn.textContent || ''; if (txt.indexOf('Sepete') === -1) return;
    var unit = unitPrice(); if (unit == null) return;
    var total = productLine(unit, getQty()) + persFee() * getQty() + crossTotal();
    var want = 'Sepete Ekle - ' + money(total);
    if (btn.textContent !== want) {
      var _now = Date.now();
      rcCount = (_now - rcTime < 60) ? rcCount + 1 : 0;
      rcTime = _now;
      if (rcCount > 30) { return; }
      writing = true; btn.textContent = want; writing = false;
    }
  }
  function setBadge() {
    if (!ready) return;
    var badge = document.querySelector('.bp-qty-promo');
    var meta = metaPromo();
    var text = meta;
    if (!text) {
      if (tags.indexOf(TAG_2A15) !== -1) text = '2 \u00dcr\u00fcn ve \u00dczeri %15 \u0130ndirim';
      else if (tags.indexOf(TAG_3AL2) !== -1) text = '3 Al 2 \u00d6de';
      else if (onSale()) text = '\u0130ndirim';
    }
    if (text) { document.querySelectorAll('.bp-badge--discount').forEach(function (mb) { mb.textContent = text; }); }
    if (badge) {
      if (text) { badge.textContent = text; badge.style.visibility = ''; badge.style.display = ''; }
      else { badge.style.display = 'none'; }
    } else if (text) {
      var row = document.querySelector('.bp-qty-row');
      if (row) {
        var span = document.createElement('span');
        span.className = 'bp-qty-promo'; span.textContent = text;
        var lbl = row.querySelector('.bp-qty-lbl');
        if (lbl && lbl.nextSibling) row.insertBefore(span, lbl.nextSibling); else row.appendChild(span);
      }
    }
  }
  function bindButton() {
    var btn = atcBtn(); if (!btn) return;
    new MutationObserver(function () { if (!writing) recompute(); }).observe(btn, { childList: true, characterData: true, subtree: true });
    setTimeout(recompute, 0);
  }
  function onInteract(e) {
    var t = e.target;
    if (t && t.closest && (t.closest('[id^="bpdp-qty-"]') || t.closest('[id^="bpdp-plus-"]') || t.closest('[id^="bpdp-minus-"]') ||
      t.closest('.bp-vbtn') || t.closest('[data-personalization]') || t.closest('.bp-cross-sell__check'))) {
      setTimeout(function () { recompute(); setBadge(); }, 0);
    }
  }
  function init() {
    var handle = getHandle(); if (!handle || (!atcBtn() && !document.querySelector('.bp-qty-promo'))) return;
    var b0 = document.querySelector('.bp-qty-promo'); if (b0) b0.style.visibility = 'hidden';
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) { if (b0) b0.style.visibility = ''; return; }
        (p.variants || []).forEach(function (v) { priceById[String(v.id)] = v.price; compareById[String(v.id)] = v.compare_at_price; });
        tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        if (tags.indexOf(TAG_3AL2) !== -1) mode = '3al2'; else if (tags.indexOf(TAG_2A15) !== -1) mode = '2a15';
        ready = true;
        if (mode) bindButton();
        setBadge();
        ['input', 'change', 'click'].forEach(function (ev) { document.addEventListener(ev, onInteract, true); });
      })
      .catch(function () { if (b0) b0.style.visibility = ''; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
/* Bellore yildiz rozeti: koleksiyon/anasayfa kartlarinda yildiz (bc-card + bhs-card, handle bazli). */
(function () {
  var R = {
    "gercek-308-mermili-ozel-hediyelik-viski-bardagi-kursunlu-300cc": "5.0|22",
    "gercek-308-mermili-ozel-fincan-kulplu-kahve-bardagi-hediyelik-340cc": "4.78|9",
    "gercek-308-mermili-sik-luks-ikili-viski-bardagi-set-unutulmaz-hediye-355cc": "4.9|21",
    "bellore-gercek-golf-toplu-ozel-hediye-viski-bardagi-300cc": "4.0|1",
    "bitcoin-madeni-para-hediyelik-ozel-viski-bardagi-300cc": "5.0|1",
    "bitcoin-madeni-para-hediyelik-ozel-fincancay-kahve-bardagi-kupa-340cc": "5.0|1",
    "bitcoin-madeni-para-hediyelik-ozel-kristal-luks-2li-viski-bardagi-set-355cc": "5.0|2",
    "poker-cipli-fisi-pullu-ozel-viski-bardagi-cip-300cc": "5.0|2",
    "poker-cipli-fisi-pullu-ozel-bira-bardagi-cip-465cc": "5.0|2",
    "poker-cipli-fisi-pullu-2li-luks-kristal-viski-bardak-seti-355cc": "5.0|12",
    "kirmizi-zarli-2li-luks-kristal-viski-bardak-seti-355cc": "5.0|2",
    "tavla-zarli-fincan-cay-kahve-bardagi-kupa-zari-340cc": "5.0|1",
    "kirmizi-zarli-ozel-bira-bardagi-zar-465cc": "5.0|1",
    "futbol-toplu-ozel-cay-kahve-bardagi-fincan-kupa-340-cc": "5.0|1",
    "gercek-308-mermili-ozel-luks-hediyelik-viski-bardagi-355cc": "4.5|4",
    "kristal-mermili-viski-bardagi": "5.0|1",
    "bellore-mermi-sekilli-paslanmaz-celik-viski-sogutucu-tas-seti-6li-buz-kupleri-tasi": "5.0|4",
    "kursungecirmez-baba-gercek-308-mermili-viski-bardagi-300cc": "5.0|2"
  };
  function html(val, size) {
    var pr = val.split("|"), avg = parseFloat(pr[0]), cnt = pr[1], full = Math.round(avg);
    var s = '<span class="bp-jm-stars" style="display:inline-flex;align-items:center;gap:1px;">';
    for (var i = 1; i <= 5; i++) { s += '<span style="color:' + (i <= full ? '#f5a623' : '#d8d8d8') + ';font-size:' + (size || 13) + 'px;line-height:1;">\u2605</span>'; }
    s += '<span style="font-size:11px;color:#777;margin-left:5px;">(' + cnt + ')</span></span>';
    return s;
  }
  function cards() {
    document.querySelectorAll('.bc-card, .bhs-card').forEach(function (card) {
      if (card.querySelector('.bp-jm-stars')) return;
      var links = card.querySelectorAll('a[href*="/products/"]');
      if (!links.length) return;
      var handle = null, titleLink = null, mediaLink = null;
      links.forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
        if (m && !handle) handle = m[1];
        if (a.querySelector('img')) { if (!mediaLink) mediaLink = a; }
        else if ((a.textContent || '').trim()) { if (!titleLink) titleLink = a; }
      });
      if (!handle || !R[handle]) return;
      var d = document.createElement('div');
      d.style.cssText = 'padding:4px 0 2px;';
      d.innerHTML = html(R[handle], 14);
      if (titleLink) { titleLink.insertAdjacentElement('afterend', d); }
      else if (mediaLink && mediaLink.parentElement) { mediaLink.parentElement.insertAdjacentElement('afterend', d); }
      else { card.appendChild(d); }
    });
  }
  function fmtTL(cents) {
    try { return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + ' TL'; }
    catch (e) { return (cents / 100).toFixed(2) + ' TL'; }
  }
  var CS_COMPARE = { "48923796340889": 269900, "48923796373657": 189900 };
  function crossSell() {
    document.querySelectorAll('.bp-cross-sell__check[data-variant-id]').forEach(function (chk) {
      var compare = CS_COMPARE[chk.getAttribute('data-variant-id')];
      if (!compare) return;
      var price = parseInt(chk.getAttribute('data-price-cents') || '0', 10);
      if (!price || compare <= price) return;
      var item = chk.closest('.bp-cross-sell__item'); if (!item) return;
      if (item.getAttribute('data-bp-cs')) return;
      var info = item.querySelector('.bp-cross-sell__info'); if (!info) return;
      var pspan = info.querySelector('span'); if (!pspan) return;
      if (chk.disabled) return;
      item.setAttribute('data-bp-cs', '1');
      var d = Math.round(((compare - price) / compare) * 100);
      pspan.innerHTML = '<span style="display:inline-block;background:#e21b1b;color:#fff;font-size:10px;font-weight:800;padding:1px 5px;border-radius:4px;margin-right:6px;vertical-align:middle;">%' + d + '</span>' +
        '<span style="text-decoration:line-through;opacity:.5;margin-right:5px;">' + fmtTL(compare) + '</span>' +
        '<span style="font-weight:700;">' + fmtTL(price) + '</span>';
    });
  }
  function run() { try { cards(); crossSell(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  [300, 900, 2000].forEach(function (ms) { setTimeout(run, ms); });
  if (window.MutationObserver) { var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(cards, 150); }).observe(document.documentElement, { childList: true, subtree: true }); }
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 50); });
})();

/* iOS pinch-zoom fix: iPhone Safari / Instagram in-app tarayici user-scalable=no'yu yok sayar.
   Parmakla (iki parmak) yakinlastirmayi JS ile engelle. Tek parmak kaydirma ve gorsele
   tiklayinca acilan buyutme etkilenmez. Android'de calysmaz (kaudirma kilitlenmesin). */
(function () {
  var isIOS = /iP(hone|od|ad)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return; // Android'de kaydirma kilitlenmesin: pinch'yi viewport (user-scalable=no) hallediyor
  function pd(e) { e.preventDefault(); }
  document.addEventListener('gesturestart', pd, { passive: false });
  document.addEventListener('gesturechange', pd, { passive: false });
  document.addEventListener('gestureend', pd, { passive: false });
  document.addEventListener('touchmove', function (e) {
    if (e.touches && e.touches.length > 1) e.preventDefault();
  }, { passive: false });
})();
